import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export class RoutesForInventory extends RoutePathBuilder {
    manage() {
        return this.url('');
    }
}
